var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VsWrapper,[_c(_setup.VsAlert,{attrs:{"type":"info"}},[(_setup.iconInfo)?_c('v-icon',{class:_setup.iconInfo.class,attrs:{"color":"blue lighten-1"}},[_vm._v(_vm._s(_setup.iconInfo.icon))]):_vm._e(),_vm._v(" "+_vm._s(_setup.message)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }